import styled from 'styled-components'

export const FiltersStyle = styled.div``
